// extracted by mini-css-extract-plugin
export default {"errorReasonOption":"DoneError_errorReasonOption__2YRMU","errorReasonGroup":"DoneError_errorReasonGroup__z0JXE"};